import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { Field } from '../../../forms/legalClientBranchNameForm';

export const LegalClientBranchNameSection = () => {
  const { t } = useTranslation();

  return (
    <Section
      datax="legalClientBranchNameSection"
      title={t('client.legal.legalClientBranch.branchName.title')}
    >
      <GridFields>
        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.legal.legalClientBranch.branchName.label')}
          name="branchName.fullName"
          placeholder={t(
            'client.legal.legalClientBranch.branchName.placeholder'
          )}
        />
      </GridFields>
    </Section>
  );
};
